import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FiMenu, FiX, FiMap, FiPhone } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Helper to handle scrolling to sections, even from other pages
  const handleScrollTo = (e, id) => {
    e.preventDefault();
    setIsMobileMenuOpen(false);
    
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 ${isScrolled || location.pathname !== '/' ? 'bg-white shadow-md py-3' : 'bg-transparent py-5'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center">
          <Link to="/" aria-label="Land Quick Home" className="flex items-center gap-2">
            <SafeIcon icon={FiMap} className={`text-3xl ${isScrolled || location.pathname !== '/' ? 'text-brand-600' : 'text-brand-500'}`} />
            <span className={`font-serif font-bold text-2xl tracking-tight ${isScrolled || location.pathname !== '/' ? 'text-stone-900' : 'text-white'}`}>
              Land<span className="text-brand-500">Quick</span>
            </span>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <button onClick={(e) => handleScrollTo(e, 'how-it-works')} className={`font-medium hover:text-brand-500 transition-colors ${isScrolled || location.pathname !== '/' ? 'text-stone-600' : 'text-stone-200'}`}>How It Works</button>
            <button onClick={(e) => handleScrollTo(e, 'benefits')} className={`font-medium hover:text-brand-500 transition-colors ${isScrolled || location.pathname !== '/' ? 'text-stone-600' : 'text-stone-200'}`}>Why Us</button>
            <a 
              href="tel:2512431403" 
              className="flex items-center gap-2 bg-brand-600 hover:bg-brand-700 text-white px-6 py-2.5 rounded-full font-semibold transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
            >
              <SafeIcon icon={FiPhone} />
              (251) 243-1403
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button 
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className={`p-2 -mr-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-brand-500 ${isScrolled || location.pathname !== '/' ? 'text-stone-900' : 'text-white'}`}
              aria-expanded={isMobileMenuOpen}
              aria-label="Toggle navigation menu"
            >
              <SafeIcon icon={isMobileMenuOpen ? FiX : FiMenu} className="text-2xl" />
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu Dropdown */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white shadow-xl absolute w-full left-0 top-full border-t border-stone-100">
          <div className="px-4 pt-2 pb-6 space-y-2">
            <button onClick={(e) => handleScrollTo(e, 'how-it-works')} className="block w-full text-left px-3 py-3 text-stone-600 font-medium rounded-lg hover:bg-stone-50">How It Works</button>
            <button onClick={(e) => handleScrollTo(e, 'benefits')} className="block w-full text-left px-3 py-3 text-stone-600 font-medium rounded-lg hover:bg-stone-50">Why Us</button>
            <a 
              href="tel:2512431403" 
              className="flex items-center justify-center gap-2 w-full px-3 py-3 bg-brand-600 text-white rounded-lg font-semibold mt-4 shadow-md"
            >
              <SafeIcon icon={FiPhone} />
              Call (251) 243-1403
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}